<template>
  <footer>
    <div class="row">
      <div class="five columns">
        <Sponsors />
      </div>
      <div class="links seven columns">
        <a href="https://portal.eo.nl/algemene-voorwaarden/">Algemene voorwaarden</a>
        |
        <a href="https://portal.eo.nl/privacyverklaring-eo/">Privacy verklaring</a>
        |
        <a href="https://www.eo.nl/cookies" class=" three  npo_cc_settings_link">Cookieinstellingen</a>
      </div>
    </div>
  </footer>
</template>

<script>
import Sponsors from './Sponsors'

export default {
  name: 'Footer',
  components: { Sponsors }
}
</script>

<style scoped lang="scss">
footer {
  padding: 1.5rem 3rem;
}

.links {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: $color-gray;

  a {
    padding: 0 1.5rem;
    font-size: 2.1rem;
    white-space: nowrap;
    text-decoration: none;
    color: $color-gray;

    &:hover {
      text-decoration: underline
    }

    @include breakpoint(min-width, $screen-hd) {
      font-size: 2.4rem;
      padding: 0 3rem;
    }
  }
}
</style>
